import { TypedUseSelectorHook, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

export interface MastheadState {
  /** ログイン完了後の遷移先。URLではなくPath以降である必要がある */
  readonly loginDonePath: string;
}

const initialState: MastheadState = {
  loginDonePath: '/'
};

/**
 * ネストしたオブジェクトを扱うこともあるためisEqualを利用して深い比較をしている
 *
 * @param selector
 * @param equalityFn
 */
export const useMastheadSelector: TypedUseSelectorHook<MastheadState> = selector =>
  useSelector((state: { masthead: MastheadState }) => selector(state.masthead), isEqual);

export default (state: MastheadState = initialState) => state;
